import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import API_URL from '../constants/environment';
import SessionContext from '../contexts/SessionContext';
import { useContext } from 'react';


export const useSubmitLogout = () => {
	const sessionContext = useContext(SessionContext);

	const submitLogout = async () => {
		axios.post(`${API_URL}/account/logout`,
			{},
			{
				headers: {
					Authorization: sessionContext?.sessionId
				}
			}
		).catch(err => {
			console.log(JSON.stringify(err));
		}).finally(() => {
			sessionContext?.logout();
		});
	};

	return useMutation({
		mutationFn: submitLogout,
	});
}; 